export default "__VITE_ASSET__9f99bf80__"